{
  "sourcing": {
    "formExamples": {
      "title": "e.g. Office supplies for the reception area"
    },
    "queueSearch": {
      "label": "Search by number, title or reason",
      "placeholder": "Number, title or reason"
    },
    "openNeedsSupplier": "Choose at least one supplier to open the enquiry.",
    "deadlineHintZone": "Applies once the enquiry is opened to suppliers. Time zone: {{zone}}."
  }
}
